export default {
  web: {
    status: {
      notFoundTitle: "Pagina non trovata",
      notFoundDescription: "La pagina che stai cercando non esiste o potrebbe essere stata spostata.",
      supportTitle: "Supporto",
      supportDescription: "Per assistenza con il tuo account o domande sui nostri servizi, contattaci via email a support@linemate.io",
      goHome: "Vai alla Home",
      exploreTrends: "Esplora trend",
      openTrends: "Apri trend",
      contactSupport: "Contatta supporto",
    },
    download: {
      title: "Scarica Linemate",
      subtitle: "Disponibile per iOS, Android e web.",
      ios: "Scarica per iOS",
      android: "Scarica per Android",
    },
    manageSubscription: {
      title: "Gestisci il tuo abbonamento",
      web: "Gestisci sul web",
      ios: "Gestisci su iOS",
      android: "Gestisci su Android",
    },
    auth: {
      loginTitle: "Accedi a Linemate",
      signupTitle: "Registrati a Linemate",
      noAccount: "Non hai un account?",
      alreadyHaveAccount: "Hai già un account?",
      signUp: "Registrati",
      setupError: "Qualcosa è andato storto durante la configurazione del tuo account. Potresti riuscire a completare il processo dalla pagina profilo.",
      usernameTooShort: "Nome utente troppo corto (min. 6 caratteri).",
      usernameAlphaNumeric: "Il nome utente può contenere solo lettere e numeri.",
      termsPrefix: "Continuando, accetti i",
      termsOfService: "Termini di servizio",
      privacyPolicy: "Informativa sulla privacy di Linemate.",
      oddsFormatTitle: "Preferenze formato quote",
      oddsFormatDescription: "Prima di continuare con Linemate, imposta la preferenza per visualizzare le quote in formato americano o decimale.",
      oddsFormat: "Formato quote",
      passwordReset: {
        forgotTitle: "Password dimenticata",
        resetTitle: "Reimposta password",
        instructions: "Inserisci l'email associata al tuo account e ti invieremo un link per reimpostare la password.",
        sentInstructions: "Riceverai presto un'email per reimpostare la password. Segui il link nell'email per reimpostarla.",
        sendInstructions: "Invia istruzioni",
        resendInstructions: "Reinvia istruzioni",
        returnToLogin: "Torna al login",
        signupPrompt: "Non hai un account? Registrati",
        sendError: "Qualcosa è andato storto durante l'invio delle istruzioni per reimpostare la password. Riprova più tardi.",
      },
      changePassword: {
        title: "Cambia la password",
        subtitle: "Inserisci la tua nuova password.",
        newPassword: "Nuova password",
        confirmNewPassword: "Conferma nuova password",
        passwordChanged: "Password cambiata",
        invalidLink: "Non siamo riusciti a reimpostare la password. Il link che stai usando non è valido o è scaduto.",
        genericError: "Non siamo riusciti a completare la richiesta. Riprova più tardi oppure invia il seguente codice al nostro team così potremo verificarlo: {{code}}",
      },
    },
    inputSelection: {
      clear: "Cancella",
    },
  },
};
